import { IForm } from 'pages/revisions-module/template-editor/editors/form/types';

const sections: IForm['sections'] = [
  { id: 'device', name: 'Údaje zariadenia', tab: 'device', rows: [] },
  {
    id: 'device-faults',
    name: 'Nedostatky',
    tab: 'faults',
    rows: [
      {
        id: 'device-faults-row-0',
        inputs: [
          {
            id: 'device-faults-row-0-input-0',
            context: 'fault',
            deletable: false,
            spec: {
              type: 'faultType',
              copyable: false,
              required: true,
              readOnly: false,
              hidden: false,
              name: 'fault',
              label: 'Nedostatok',
            },
          },
          {
            id: 'device-faults-row-0-input-1',
            context: 'fault',
            deletable: false,
            spec: {
              type: 'faultSeverity',
              copyable: false,
              required: true,
              readOnly: false,
              hidden: false,
              name: 'severity',
              label: 'Závažnosť',
            },
          },
          {
            id: 'device-faults-row-0-input-2',
            context: 'fault',
            deletable: false,
            spec: {
              type: 'text',
              copyable: false,
              required: false,
              readOnly: false,
              hidden: false,
              name: 'moreInfo',
              label: 'Popis',
            },
          },
          {
            id: 'device-faults-row-0-input-4',
            context: 'fault',
            deletable: false,
            spec: {
              type: 'checkbox',
              copyable: false,
              required: false,
              readOnly: false,
              hidden: true,
              name: 'observation',
              label: 'Nutné pozorovanie',
            },
          },
          {
            id: 'device-faults-row-0-input-3',
            context: 'fault',
            deletable: false,
            spec: {
              type: 'fileList',
              copyable: false,
              required: false,
              readOnly: false,
              hidden: false,
              name: 'attachments',
              label: 'Prílohy',
              accept: 'image/*',
              maxFiles: 5,
            },
          },
        ],
      },
    ],
  },
  {
    id: 'basic-info',
    name: '',
    tab: 'info',
    rows: [
      {
        id: 'basic-info-row-0',
        inputs: [
          {
            id: 'datum-ukoncenia',
            context: 'revision',
            deletable: true,
            spec: {
              type: 'date',
              copyable: false,
              required: true,
              readOnly: false,
              hidden: false,
              name: 'datum-ukoncenia',
              label: 'Dátum ukončenia',
            },
          },
        ],
      },
    ],
  },
  {
    id: 'conclusion',
    name: 'Záver',
    tab: 'conclusion',
    rows: [
      {
        id: 'conclusion-row-0',
        inputs: [
          {
            id: 'zaver-reviznej-spravy',
            context: 'revision',
            deletable: true,
            spec: {
              type: 'safetyPoint',
              copyable: false,
              required: true,
              readOnly: false,
              hidden: false,
              name: 'zaver-reviznej-spravy',
              label: 'Záver revíznej správy',
              suitableText: 'Vyhovuje',
              notSuitableText: 'Nevyhovuje',
              withReservationsText: 'Vyhovuje s výhradami',
            },
          },
        ],
      },
    ],
  },
];

const inputNames = sections.flatMap(({ rows }) => rows.flatMap(({ inputs }) => inputs.map(({ spec }) => spec.name)));

export const DEFAULT_FORM: IForm = { sections, inputNames };
